import { FormWithRedux } from '../../FormWithRedux';
import React from 'react';

export class ACCBISTRecollectionFailureCheck5Form extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('recollectionFailureCheck5Subform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        let firstCheck = this.getValue('recollectionCheck5');
        if(firstCheck != null && firstCheck != undefined && firstCheck.length < 3) {
            return true;
        } 

        return false;
    }

    getValueType(identifier) {
        return 'object';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }

    detailForIdentifier(prefix, value) {
        if (value.identifier === 'recollectionFailureCheck5' && this.getValue(value.identifier) != null) {
            let value = this.getValue('recollectionFailureCheck5');
            if (value.length == 0) {
                return prefix + 'No images recalled';
            }
            else {
                return prefix + 'Recalled ' + value.length + ' image' + (value.length == 1 ? '' : 's');
            }
        }

        return super.detailForIdentifier(prefix, value);
    }

    htmlForIdentifier(prefix, value) {
        if (value.identifier === 'recollectionFailureCheck5' && this.getValue(value.identifier) != null) {
            let value = this.getValue('recollectionFailureCheck5');
            if (value.length == 0) {
                return (<div key={value.identifier} >
                    <label className='list-detail'>{'No images recalled'}</label>
                </div>);
            }
            else {
                return (<div key={value.identifier} >
                    <label className='list-detail'>{'Recalled ' + value.length + ' image' + (value.length == 1 ? '' : 's')}</label>
                </div>);
            }
        }
        else {
            return super.htmlForIdentifier(prefix, value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-RecollectionFailureCheck5Form.js